import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M6.05435 9.48138L12.1656 3.54758C12.4602 3.26148 12.9382 3.26148 13.2328 3.54758L13.9457 4.23976C14.24 4.52555 14.2403 4.98843 13.9469 5.27483L9.10354 9.99952L13.9466 14.7245C14.2403 15.0109 14.2397 15.4738 13.9454 15.7596L13.2325 16.4518C12.9379 16.7379 12.4599 16.7379 12.1653 16.4518L6.05435 10.5177C5.75972 10.2316 5.75972 9.76747 6.05435 9.48138Z"
      fill="#070F21"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const ArrowIcon = memo(ForwardRef);
export default ArrowIcon;
